/**
 * Um POST de navegacao, feito com um formulario escondido.
 *
 * E como a SPA cumpre "logout so por POST" do design: `end_session_endpoint`
 * por GET levaria o `id_token_hint` na query, e token em URL e a proibicao numero
 * um do contrato do IDP — ficaria no historico do navegador e no log do IDP.
 */
export function submitPostForm(url: string, params: Readonly<Record<string, string>>): void {
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = url;
  form.style.display = 'none';

  Object.entries(params).forEach(([name, value]) => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    form.appendChild(input);
  });

  document.body.appendChild(form);
  form.submit();
}
